<!--
  @name:
  @author: dgq
  @time:
-->

<template>
	<basic-container>
		<avue-crud
			v-model="formData"
			:page.sync="page"
			v-bind="bindVal"
			v-on="onEvent"
			@on-load="getList"
			@refresh-change="refreshChange"
			@search-reset="searchChange"
			@search-change="searchChange"></avue-crud>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

const option = {
	//模块名字
	name: 'insureTypeIndex',
	optionPath: 'product/productManage',
	optionNameList: ['insureTypeOption'],
	apiPath: 'product/productManage',
	//接口名字
	apiNameList: ['getInsureTypeList'],
	apiNameAddList: ['addInsureType'],
	apiNameUpdateList: ['editInsureType'],
	apiNameDelList: ['delInsureType'],
	//如有时间搜索，则必填，例如['payTime','payTimeStart','payTimeEnd']
	searchData: [],
	//主键
	rowKey: 'id',
}
export default window.$baseCrud(
	{
		data() {
			return {}
		},
		methods: {
			//可以重写getList() {},
			//列表前操作方法
			listBefore() {},
			//列表后操作方法
			listAfter() {},
			//请求错误
			listError() {},
			//请求finally
			listFinally() {},
			//额外添加请求参数
			addRequestData() {
				return {}
			},
		},
	},
	option,
)
</script>

<style lang="scss" scoped></style>
